import React from 'react';
import { useHistory } from 'react-router-dom';

import stat1 from 'web/assets/images/stat1.png';
import stat2 from 'web/assets/images/stat2.png';
import stat3 from 'web/assets/images/stat3.png';
import stat4 from 'web/assets/images/stat4.png';

import styles from './gridSection.module.scss';
const GridSection = ({ dashbaordResponse }) => {
    let history = useHistory();
    return (
        <div className={styles.statsSection}>
            <div>
                <p onClick={() => { history.push('/MyPost') }}><img src={stat1} />MY POSTS</p>
                <div> {dashbaordResponse.totalNumberPost ?
                    <h3>{dashbaordResponse.totalNumberPost}</h3> : <h3>0</h3>}
                    <p>Total Posts</p></div>
            </div>
            <div>
                <p onClick={() => { history.push('/MyBids') }}><img src={stat2} />My Activities</p>
                <div> {dashbaordResponse.totalNumberBids ? <h3>{dashbaordResponse.totalNumberBids}</h3> : <h3>0</h3>}
                    <p>Total Activities</p></div>
            </div>
            <div>
                <p><img src={stat3} />My Orders</p>
                <div> <h3>0</h3><p>Pending Order</p></div>
            </div>
            <div>
                <p><img src={stat4} />My Disputes</p>
                <div> <h3>0</h3><p>Claimed</p></div>
            </div>
        </div>
    )
}

export default GridSection;
